<template>
    <div class="my-order-view">
      <div class="user-account">
        <div class="user-text">账号</div>
        <input class="input-content" type="text"/>
      </div>
      <div class="user-password">
        <div class="user-text">密码</div>
        <input class="input-content" type="password"/>
      </div>
      <div class="login-btn">
        登陆
      </div>
    </div>
</template>

<script>
export default {
  name: 'myorder'
}
</script>

<style scoped>
  .my-order-view{
    width: 100%;
    flex-grow: 1;
    background: url("../assets/myorder.jpg") no-repeat fixed top;
    background-size: cover;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    display: flex;
    position: relative;
  }
  .user-account{
    /*width: 100%;*/
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    display: flex;
    position: relative;
    border-bottom: solid 0.2rem white;
  }
  .user-password{
    margin-top: 2rem;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    display: flex;
    position: relative;
    border-bottom: solid 0.2rem white;

  }
  .user-text{
    font-size:1.75rem;
    font-weight:400;
    line-height:2.31rem;
    color:rgba(255,255,255,1);
  }
  .input-content{
    margin-left: 2rem;
    width: 25rem;
    height: 2.5rem;
    /*background-color:white;*/
    background-color: #00000000;
    border: #00000000;
    font-size:1.75rem;
    font-weight:bold;
    line-height:2.31rem;
    color:rgba(255,255,255,1);
    /*border-bottom: solid 0.2rem #ffffff;*/
  }
  .login-btn{
    width: 25%;
    height: 5.5rem;
    margin-top: 2rem;
    background-color: #FDAF00;
    background-size: cover;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    display: flex;
    position: relative;
    font-size:3.25rem;
    font-family:Microsoft YaHei;
    font-weight:bold;
    line-height:4.31rem;
    color:rgba(255,255,255,1);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/myorder.vue